import React from "react";
import { Button, Grid, Typography, IconButton, Box } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import FilterListIcon from "@mui/icons-material/FilterList";

const propertyTypes = ["House", "Apartment", "Villa", "Office"];
const availabilityTypes = ["Rent", "Buy", "Lease"];
const priceRanges = [
  { min: 0, max: 5000000, label: "Under ₹50L" },
  { min: 5000000, max: 10000000, label: "₹50L - ₹1Cr" },
  { min: 10000000, max: 20000000, label: "₹1Cr - ₹2Cr" },
  { min: 20000000, max: Number.MAX_SAFE_INTEGER, label: "Above ₹2Cr" },
];

const FilterSection = ({ filters, setFilters, onApplyFilters }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePriceRangeChange = (min, max) => {
    setFilters((prev) => ({
      ...prev,
      priceRange: [min, max],
    }));
  };

  const handleReset = () => {
    setFilters({
      propertyType: "",
      priceRange: [0, Number.MAX_SAFE_INTEGER],
      bedrooms: "0",
      bathrooms: "0",
      availability: "",
      searchQuery: "",
      sortBy: "",
    });
  };

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        p: 3,
        borderRadius: 2,
        boxShadow: 1,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <FilterListIcon sx={{ color: "primary.main" }} />
          <Typography variant="h6" fontWeight="bold">
            Filters
          </Typography>
        </Box>
        <Button
          onClick={handleReset}
          variant="text"
          color="primary"
          sx={{ textTransform: "none" }}
        >
          Reset All
        </Button>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        {/* Property Type */}
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
            <HomeIcon sx={{ color: "primary.main" }} />
            <Typography variant="subtitle1" fontWeight="bold">
              Property Type
            </Typography>
          </Box>
          <Grid container spacing={1}>
            {propertyTypes.map((type) => (
              <Grid item xs={6} key={type}>
                <Button
                  fullWidth
                  variant={
                    filters.propertyType === type.toLowerCase()
                      ? "contained"
                      : "outlined"
                  }
                  color="primary"
                  onClick={() =>
                    handleChange({
                      target: {
                        name: "propertyType",
                        value: type.toLowerCase(),
                      },
                    })
                  }
                  sx={{
                    textTransform: "none",
                    borderRadius: 2,
                    height: "40px",
                  }}
                >
                  {type}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Price Range */}
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
            <AttachMoneyIcon sx={{ color: "primary.main" }} />
            <Typography variant="subtitle1" fontWeight="bold">
              Price Range
            </Typography>
          </Box>
          <Grid container spacing={1}>
            {priceRanges.map(({ min, max, label }) => (
              <Grid item xs={6} key={label}>
                <Button
                  fullWidth
                  variant={
                    filters.priceRange[0] === min &&
                    filters.priceRange[1] === max
                      ? "contained"
                      : "outlined"
                  }
                  color="primary"
                  onClick={() => handlePriceRangeChange(min, max)}
                  sx={{
                    textTransform: "none",
                    borderRadius: 2,
                    height: "40px",
                  }}
                >
                  {label}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Apply Filters Button */}
        <Box sx={{ mt: 4 }}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => onApplyFilters(filters)}
            sx={{
              textTransform: "none",
              height: "48px",
              borderRadius: 2,
            }}
          >
            Apply Filters
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default FilterSection;
